export default __webpack_public_path__ + "static/media/gmail-clone.df5ed41a.svg";